/* ============================================================
   SIMPLE CLIMA — Scripts personalizados (JS de apoyo del tema)
   ============================================================
   Todo el JS propio del proyecto (aparte del de precios) vive
   aquí. Se carga desde layout/theme.liquid con "defer".

   CONTIENE:
   1. FILTROS DE COLECCIÓN — limpia los filtros/facetas:
      (a) Oculta la opción de filtro "excluido-con-script". Ese
          es un valor agrupado que junta tags que NO deben verse
          como opciones de filtro (marca: Daikin/Trane/York, y
          disponibilidad: disponible/no-disponible). El filtro se
          configura en el admin de Shopify, pero la OPCIÓN visible
          igual aparece, así que aquí la ocultamos por JS.
      (b) En /collections/minisplits, oculta toda la sección de
          filtro "Productos" (tipo de equipo), porque en esa
          colección no aplica.
   2. BLOG "Ver más" — código COMENTADO (en desuso, ver abajo).

   NOTA sobre badges de disponibilidad:
   NO se aplican aquí. Se renderizan con Liquid vía el snippet
   '_simpleclima-badge' en cada tarjeta (cero peticiones HTTP).

   NOTA sobre el reproceso con MutationObserver (al final):
   los filtros de Shopify se regeneran al filtrar/paginar, así
   que se observan los contenedores del grid y de las facetas
   para volver a ocultar lo que corresponde cada vez que cambian.
   ============================================================ */

(function () {
  'use strict';

  /* ═══════════════════════════════════════════════════════════
     1. FILTROS DE COLECCIÓN
     ═══════════════════════════════════════════════════════════ */

  function ocultarFiltroExcluido() {
    document.querySelectorAll('.facet-checkbox__label').forEach(function (label) {
      if (label.textContent.trim().toLowerCase().startsWith('excluido-con-script')) {
        var li = label.closest('li');
        if (li) li.style.display = 'none';
      }
    });
  }

  function ocultarSeccionProductosEnMinisplits() {
    if (window.location.pathname === '/collections/minisplits') {
      document.querySelectorAll('.facets__disclosure').forEach(function (details) {
        var titulo = details.querySelector('.facets__summary-title');
        if (titulo && titulo.textContent.trim().toLowerCase().startsWith('productos')) {
          details.style.display = 'none';
        }
      });
    }
  }

  function ejecutarFiltros() {
    ocultarFiltroExcluido();
    ocultarSeccionProductosEnMinisplits();
  }

  /* ═══════════════════════════════════════════════════════════
     2. BLOG — Botón "Ver más" con tandas [11, 8, 5]
     ⚠️ EN DESUSO: todo este bloque está COMENTADO. Fue un intento
     de cargar las notas del blog por tandas con un botón "Ver más"
     (11 primero, luego 8, luego 5). No se llegó a usar; el blog
     usa la paginación nativa del tema. Se conserva por si se
     retoma. Su CSS asociado también está comentado en
     _simpleclima-blog.css. La llamada iniciarBlogVerMas() al
     final también está comentada.
     ═══════════════════════════════════════════════════════════ */

  // function iniciarBlogVerMas() {
  //   var grid = document.querySelector('.blog-articles__grid');
  //   if (!grid) return; // no estamos en el blog

  //   var TANDAS = [11, 8, 5];
  //   var articulos = Array.prototype.slice.call(
  //     document.querySelectorAll('.blog-articles__article')
  //   );
  //   var total = articulos.length;
  //   var visibles = 0;
  //   var indiceTanda = 0;

  //   function mostrarSiguienteTanda() {
  //     var cantidad = TANDAS[indiceTanda] || 0;
  //     var siguiente = visibles + cantidad;
  //     articulos.forEach(function (art, i) {
  //       if (i >= visibles && i < siguiente) {
  //         art.classList.remove('sc-oculto');
  //       }
  //     });
  //     visibles = siguiente;
  //     indiceTanda++;
  //   }

  //   articulos.forEach(function (art) {
  //     art.classList.add('sc-oculto');
  //   });
  //   mostrarSiguienteTanda();

  //   var btnWrapper = document.createElement('div');
  //   btnWrapper.className = 'sc-load-more-wrapper';
  //   btnWrapper.innerHTML =
  //     '<button class="button button--tertiary js-load-more" id="sc-btn-ver-mas">' +
  //     'Ver más' +
  //     '<svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">' +
  //     '<circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>' +
  //     '</svg>' +
  //     '</button>';

  //   grid.parentNode.insertBefore(btnWrapper, grid.nextSibling);

  //   function actualizarVisibilidadBoton() {
  //     if (visibles >= total) {
  //       btnWrapper.classList.add('sc-oculto');
  //       var paginacion = document.querySelector('.pagination-wrapper');
  //       if (paginacion) {
  //         paginacion.style.setProperty('display', 'block', 'important');
  //       }
  //     }
  //   }

  //   actualizarVisibilidadBoton();

  //   document.getElementById('sc-btn-ver-mas').addEventListener('click', function () {
  //     mostrarSiguienteTanda();
  //     actualizarVisibilidadBoton();
  //   });
  // }

  /* ═══════════════════════════════════════════════════════════
     INICIALIZACIÓN
     ═══════════════════════════════════════════════════════════ */

  document.addEventListener('DOMContentLoaded', function () {
    ejecutarFiltros();

    var gridContainer = document.getElementById('ProductGridContainer');
    if (gridContainer) {
      new MutationObserver(ejecutarFiltros)
        .observe(gridContainer, { childList: true, subtree: true });
    }

    var facetsWrapper = document.getElementById('FacetsWrapperDesktop');
    if (facetsWrapper) {
      new MutationObserver(ejecutarFiltros)
        .observe(facetsWrapper, { childList: true, subtree: true });
    }

    // iniciarBlogVerMas();
  });
})();
